import { Form, Input, Button } from "antd";

import { CustomerSideNextScreenConstants } from "../../../constants/generalConstants";
import { useUpdatePassword } from "./index.hook";
import styles from "./index.module.css";
import { General } from "../../../util/General";
import FormInputRules from "../../../util/FormInputRules";
import CircularProgressBar from "../../common/CircularProgressBar";

import type { AuthUserAPIResponse } from "../../../shared/interface/auth/User.interface";
import { ErrorMessageConstants } from "../../../constants/MessageConstants/ErrorMessageConstants";

type UpdatePasswordProps = {
  nextScreenHelper: (response: AuthUserAPIResponse) => void;
  handleNextScreen: (value: CustomerSideNextScreenConstants | null) => void;
};

const UpdatePassword = (props: UpdatePasswordProps) => {
  const config = useUpdatePassword(props);

  return (
    <>
      <Form onFinish={config?.onFinish} layout="vertical" autoComplete="off" validateTrigger="onBlur" name="basic" className={`gx-signin-form gx-form-row0 gx-mb-4`}>
        <h3 className="gx-mt-2 gx-mb-4 ">Please update your password.</h3>

        <Form.Item initialValue={null} name="newPassword" normalize={General.inputWhiteSpaceRemove} label="New Password" hasFeedback rules={[FormInputRules.requiredFieldInputRule("new password"), ...FormInputRules.getStrongPasswordRule()]}>
          <Input.Password autoComplete="new-password" placeholder="New Password" type="password" name="newPassword" onCopy={(e) => e.preventDefault()} />
        </Form.Item>

        <Form.Item
          initialValue={null}
          name="confirmPassword"
          label="Confirm Password"
          normalize={General.inputWhiteSpaceRemove}
          hasFeedback
          rules={[
            FormInputRules.requiredFieldInputRule("confirm password"),
            ({ getFieldValue }) => ({
              validator(rule, value) {
                if (!value || getFieldValue("newPassword") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error(ErrorMessageConstants.NEW_AND_CONFIRM_PASSWORD_DO_NOT_MATCH));
              }
            })
          ]}
        >
          <Input.Password autoComplete="new-password" placeholder="Confirm Password" type="password" name="confirmPassword" onCopy={(e) => e.preventDefault()} />
        </Form.Item>

        <div className={`${styles["password-btn-container"]} gx-mt-4`}>
          <Button className={`${styles["password-form-button"]} button-gradiant gx-mb-0`} onClick={config.handleBack}>
            Back
          </Button>

          <Button className={`${styles["password-form-button"]} button-gradiant gx-mb-0`} htmlType="submit" disabled={config.loader}>
            {config.loader ? <CircularProgressBar /> : "Submit"}
          </Button>
        </div>
      </Form>
    </>
  );
};
export default UpdatePassword;
